<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_proofingType') || '打样类型'"
            prop="proofingType"
          >
            <dict-select
              filterable
              size="small"
              clearable
              v-model="formData.proofingType"
              :body="proofingTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_demandTime') || '需求时间'"
            prop="demandTime"
          >
            <el-date-picker
              size="small"
              style="width:100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              v-model="formData.demandTime"
              type="date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_qty') || '需求数量'"
            prop="qty"
          >
            <el-input
              v-model="formData.qty"
              style="width:100%"
              controls-position="right"
              size="small"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_sampleUse') || '样品用途'"
            prop="sampleUse"
          >
            <el-input
              v-model="formData.sampleUse"
              type="textarea"
              rows="3"
              clearable
              maxlength="1000"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_proofingRequirement') || '交付要求'"
          >
            <el-input
              v-model="formData.proofingRequirement"
              type="textarea"
              rows="3"
              clearable
              maxlength="1000"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.proofing_label_photoRequirement') || '拍摄要求'"
          >
            <el-input
              v-model="formData.photoRequirement"
              type="textarea"
              rows="3"
              clearable
              maxlength="1000"
              show-word-limit
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <goods-table
            class="mt-2"
            :disabled="disabled"
            :changeOrderCode="changeOrderCode"
            :tableData.sync="formData.items"
            ref="goodsTable"
          />
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GoodsTable from './goods-table.vue'
const initFrom = {
  orderGoodsProofingStatus: 'N',
  orderGoodsNo: '',
  items: [],
}
export default {
  components: {
    GoodsTable,
  },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    code: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    isCopy: { type: Boolean, default: false },
  },
  data() {
    return {
      goodsProofingData: [],
      backDialogVisible: false,
      proofingTypeParams: { dictType: 'proofingType' },
      formData: { ...initFrom },
      rules: {
        proofingType: [
          {
            required: true,
            message: this.$l('tips_select_proofingType') || '请选择打样类型',
            trigger: 'blur',
          },
        ],
        orderGoodsNo: [
          {
            required: true,
            message: this.$l('tips_select_orderGoodsNo') || '请选择订单产品',
            trigger: 'blur',
          },
        ],
        demandTime: [
          {
            required: true,
            message:
              this.$l('tips_proofing_label_demandTime') || '请选择需求时间',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .changeOrderProofingDetailApi({
          changeOrderProofingCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          if (this.isCopy){
            this.formData.changeOrderProofingCode = ''
            const proofingList = this.formData.items
            proofingList.forEach((item) => {
              item.orderProofingGoodsCode = ''
            })
          }
        })
    },

    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      var qty = 0
      if (this.formData.items) {
        this.formData.items.forEach((item) => {
          qty += parseInt(item['goosQty'])
        })
      }
      this.loadingOpen()
      console.log(this.code)
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (this.code) {
        console.log('???')
        saveApi = this.$api.changeOrderProofingEditSaveApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
          qty: qty,
        })
      } else {
        saveApi = this.$api.changeOrderProofingAddSaveApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
          qty: qty,
        })
      }
      saveApi
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.goodsProofingData = []
      this.$emit('close')
    },
  },
}
</script>
